import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const ProfileStyles: moduleStyleType = {
    profileKey: {
        borderBottom: 0,
    },
    profileValue: {
        overflowWrap: 'anywhere',
        minWidth: '200px',
        borderBottom: 0,
    },
    headerCell: {
        borderBottom: '1px solid',
        borderColor: 'border.subtle',
    },
}
